import React from "react";

import {
	IGenericHistoryType
} from "./GameHistoryTypes";
import { ILanguageType } from "./GlobalTypes";

export interface IRoadmapSmallProps {
    pcode: string;
	history: IGenericHistoryType[];
	historyBlink: boolean;
	filter: string;
    langdata: ILanguageType;

    //Desktop
    showLobbyGameGroup?: boolean;
    lobbyDesktop?: boolean;

    small?: boolean;

    //Mobile
    mobile?: boolean;
    lobbyMobile?: boolean;
    orientation?: string;
}

export class IRoadmapSmallClass extends React.Component<IRoadmapSmallProps> {
    firstDisplayedCol: number;
    totalColumns: number;

    currentDisplayRow: number;
    currentDisplayCol: number;
    currentType: string;

    roadmapArray: JSX.Element[][];
}
